module.exports = __webpack_public_path__ + "img/header-diamondJewelryColliers@2x.372ae81.jpg";